const ProgressBar = ({ progress }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-[hsl(var(--bg-card))]/95 backdrop-blur-sm border-b border-[hsl(var(--border-light))] py-3 sm:py-4 md:py-5">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Labels */}
        <div className="flex items-center justify-between mb-1.5 sm:mb-2">
          <span className="text-xs sm:text-sm font-semibold text-[hsl(var(--text-secondary))] uppercase tracking-wide" style={{ letterSpacing: '0.05em' }}>
            Progreso del análisis
          </span>
          <span className="text-xs sm:text-sm font-semibold text-[hsl(var(--text-secondary))] uppercase tracking-wide" style={{ letterSpacing: '0.05em' }}>
            Completado {Math.round(progress)}%
          </span>
        </div>
        
        {/* Progress Bar */}
        <div className="h-2 sm:h-2.5 bg-[hsl(var(--border-light))] rounded-full overflow-hidden">
          <div
            className="h-full rounded-full"
            style={{
              width: `${progress}%`,
              background: 'linear-gradient(90deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%)',
              transition: 'width 0.6s cubic-bezier(0.2, 0.8, 0.2, 1)'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
